import Toast from './toast'
import ToastLink from './link'

export default Toast
export { ToastLink }
